const scope = process.env.REACT_APP_APP_SCOPE || "full";

const SCOPES = {
  full: {
    home: "/",
    routes: ["home", "auth", "dashboard", "utilities", "chat", "games", "blog", "movies"],
    brand: "DevPartners",
  },
  portal: {
    home: "/",
    routes: ["portal"],
    brand: "grow-emphatic.com",
  },
  auth: {
    home: "/login",
    routes: ["auth"],
    brand: "Sign in",
  },
  utilities: {
    home: "/utility/json-formatter",
    routes: ["auth", "utilities"],
    brand: "Utilities",
  },
  blogs: {
    home: "/blog/create",
    routes: ["auth", "blog"],
    brand: "Blogs",
  },
  chats: {
    home: "/chat",
    routes: ["auth", "chat"],
    brand: "Chats",
  },
  games: {
    home: "/game/tic-tac-toe",
    routes: ["auth", "games"],
    brand: "Games",
  },
  movies: {
    home: "/movies",
    routes: ["auth", "movies"],
    brand: "Movies",
  },
};

export function getAppScope() {
  return SCOPES[scope] ? scope : "full";
}

export function getScopeConfig() {
  return SCOPES[getAppScope()];
}

export function isRouteEnabled(group) {
  return getScopeConfig().routes.includes(group);
}

export const portalApps = [
  { id: "memories", title: "Memories", description: "Archive photos and files", url: "https://memories.grow-emphatic.com", localUrl: "http://localhost:3000" },
  { id: "utilities", title: "Utilities", description: "JSON, hashes, QR codes, and more", url: "https://utilities.grow-emphatic.com", localUrl: "http://localhost:3002" },
  { id: "blogs", title: "Blogs", description: "Write and publish articles", url: "https://blogs.grow-emphatic.com", localUrl: "http://localhost:3003" },
  { id: "chats", title: "Chats", description: "Direct messages and rooms", url: "https://chats.grow-emphatic.com", localUrl: "http://localhost:3004" },
  { id: "games", title: "Games", description: "Tic-tac-toe, mosquito, dragon", url: "https://games.grow-emphatic.com", localUrl: "http://localhost:3005" },
  { id: "movies", title: "Movies", description: "Browse shows and book seats", url: "https://movies.grow-emphatic.com", localUrl: "http://localhost:3006" },
];

export function resolveAppUrl(app) {
  const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  return isLocal ? app.localUrl : app.url;
}

export default SCOPES;
